import {
  CognitoUser,
  CognitoUserPool,
  CookieStorage,
} from "amazon-cognito-identity-js";
import { deleteAllCookies, getCookie } from "./utilsCookie";
import { UserDadaType } from "@context/auth/types";
import {
  REFRESH_TOKEN_EXPIRED,
  isSessionExpiredTriggered,
  triggerSessionExpired,
} from "./utilsSessionExpiredBus";

let userPool: CognitoUserPool | undefined = undefined;
let cognitoCurrentUser: CognitoUser | null = null;
let corporate_domain: string | null = null;

export const cognitoApp = {
  createCognitoUser(
    clientId: string,
    userpoolId: string,
    external_id: string,
    refreshToken: string,
    authToken: string,
    idToken: string,
    domain: string,
  ) {
    const expires = 0.3;
    userPool = new CognitoUserPool({
      ClientId: clientId,
      UserPoolId: userpoolId,
      Storage: new CookieStorage({
        secure: true,
        domain: process.env.REACT_APP_DOMAIN_COGNITO,
        expires: expires,
      }),
    });

    const cookieUser = new CookieStorage({
      secure: true,
      domain: process.env.REACT_APP_DOMAIN_COGNITO,
      expires: expires,
    });
    cookieUser.setItem(
      `CognitoIdentityServiceProvider.${clientId}.${external_id}.clockDrift`,
      "0",
    );
    cookieUser.setItem(
      `CognitoIdentityServiceProvider.${clientId}.${external_id}.refreshToken`,
      refreshToken,
    );
    cookieUser.setItem(
      `CognitoIdentityServiceProvider.${clientId}.${external_id}.accessToken`,
      authToken,
    );
    cookieUser.setItem(
      `CognitoIdentityServiceProvider.${clientId}.${external_id}.idToken`,
      idToken,
    );
    cookieUser.setItem(
      `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`,
      external_id,
    );
    cognitoCurrentUser = userPool.getCurrentUser();
    corporate_domain = domain;
  },
  // Ricostruisce l'utente dai cookie Cognito esistenti senza sovrascriverli;
  // ritorna l'utente se presente, altrimenti null.
  restoreCognitoUserFromStorage(
    clientId: string,
    userpoolId: string,
    domain: string,
  ) {
    const pool = new CognitoUserPool({
      ClientId: clientId,
      UserPoolId: userpoolId,
      Storage: new CookieStorage({
        secure: true,
        domain: process.env.REACT_APP_DOMAIN_COGNITO,
        expires: 0.3,
      }),
    });
    const currentUser = pool.getCurrentUser();
    if (currentUser) {
      userPool = pool;
      cognitoCurrentUser = currentUser;
      corporate_domain = domain;
    }
    return currentUser;
  },
  getUserpool() {
    return userPool;
  },
  getCognitoCurrentUser() {
    return cognitoCurrentUser;
  },
  getCorporate_domain() {
    return corporate_domain;
  },
};

Object.freeze(userPool);
Object.freeze(cognitoCurrentUser);
Object.freeze(corporate_domain);

export const redirectToLearner = (
  redirectObjOrMessage?: any,
  reason?: string,
) => {
  if (redirectObjOrMessage) {
    if (typeof redirectObjOrMessage === "string") {
      sessionStorage.setItem("adminRedirectMessagePage", redirectObjOrMessage);
    } else {
      // Error obj has passed, generate the string message
      sessionStorage.setItem(
        "adminRedirectMessagePage",
        `${redirectObjOrMessage.request?.requestURL} ${redirectObjOrMessage.message}`,
      );
    }
  }
  const corporate_domain = getCookie("corporate_domain");
  if (corporate_domain && corporate_domain !== "") {
    //window.location.href = corporate_domain;
    window.location.href = `${process.env.REACT_APP_ADMIN_LINK}redirectError`;
  } else if (process.env.REACT_APP_LEARNER_LINK) {
    // Session fully expired (TTL) with no corporate_domain cookie: send the user
    // to the portal login instead of the ObsoletePage dead-end.
    const loginUrl = `${process.env.REACT_APP_LEARNER_LINK}`;
    if (reason === REFRESH_TOKEN_EXPIRED) {
      if (triggerSessionExpired({ loginUrl })) return;
    } else if (isSessionExpiredTriggered()) {
      // A session-expired modal is already being shown for a previous error
      // in this same failure chain: don't race it with a silent redirect.
      return;
    }
    window.location.href = loginUrl;
  } else {
    // Fallback when the learner portal URL is not configured for this env.
    window.location.href = `${process.env.REACT_APP_ADMIN_LINK}ObsoletePage`;
  }
};

export const parseJwt = (token: string) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
};

export async function handleSwitchToLearner(user: UserDadaType) {
  const cognitoUser = cognitoApp.getCognitoCurrentUser();

  // Read mode from the cached token, without getSession(): a refresh here would
  // fail and throw when the refresh token is expired/revoked.
  let mode = "";
  const idToken = cognitoUser
    ?.getSignInUserSession()
    ?.getIdToken()
    ?.getJwtToken();
  if (idToken) {
    try {
      const tokenParse = parseJwt(idToken);
      mode = "identities" in tokenParse ? "SSO" : "Cognito";
    } catch {
      /* leave mode empty */
    }
  }

  const sessionId = getCookie("sessionId");
  const initiativeUrl = getCookie("initiativeUrl");
  const target =
    `${
      initiativeUrl !== "" ? initiativeUrl : user.corporate_domain
    }?seed_session=${sessionId}&mode=${mode}` || "";

  // signOut() without a callback does NOT revoke the refresh token (revoking it
  // here breaks a later refresh with "Refresh Token has been revoked").
  cognitoUser?.signOut();
  deleteAllCookies();
  window.location.href = target;
}
